import inventoryCatalogBooks from "./inventoryCatalogBooks";

export default [
  {
    path: "books",
    name: "books-menu",
    component: () => import("@/views/Books.vue"),
    children: [
      {
        path: "/books",
        name: "books",
        component: () => import("@/views/books/Menu"),
        meta: { IsParent: true }
      },
      {
        path: "/books/OrderBooks",
        name: "orderBooks",
        component: () => import("@/views/books/orderBooks/Wrapper"),
        children: [
          {
            path: "",
            name: "orderBooks",
            component: () => import("@/views/books/orderBooks/Main")
          },
          {
            path: "/books/OrderBooks/request",
            name: "bookRequestSearch",
            component: () =>
              import("@/views/books/orderBooks/BookRequestSearch")
          }
        ]
      },
      {
        path: "/books/ManageBooks",
        name: "bookManagement",
        component: () => import("@/views/books/bookManagement/Wrapper"),
        children: [
          {
            path: "",
            name: "bookManagement",
            component: () => import("@/views/books/bookManagement/Main")
          }
        ]
      },
      {
        path: "/books/BooksCatalog",
        name: "booksCatalog",
        component: () => import("@/views/books/booksCatalog/Wrapper"),
        children: [
          {
            path: "",
            name: "booksCatalog",
            component: () => import("@/views/books/booksCatalog/Main")
          },
          {
            path: "/books/BooksCatalog/Add",
            name: "AddBooksCatalog",
            component: () =>
              import("@/views/books/booksCatalog/AddEditReadBooksCatalog")
          },
          {
            path: "/books/BooksCatalog/edit/:id",
            name: "EditBooksCatalog",
            component: () =>
              import("@/views/books/booksCatalog/AddEditReadBooksCatalog")
          },
          {
            path: "/books/BooksCatalog/read/:id",
            name: "ReadBooksCatalog",
            component: () =>
              import("@/views/books/booksCatalog/AddEditReadBooksCatalog")
          }
        ]
      },
      ...inventoryCatalogBooks
    ]
  }
];
